// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.year-picker {
  width: 256px;
  background: rgb(var(--white));
  box-shadow: 0px 0px var(--shadow-blur-big) var(--shadow-gray);
  border-radius: var(--border-radius);
  -webkit-user-select: none;
          user-select: none;
}
.year-picker__header {
  font-weight: bold;
  color: rgb(var(--base-80));
  line-height: 40px;
}
.year-picker__body {
  padding: var(--spacing3) var(--spacing1);
}
.year-picker__bottom {
  padding: var(--spacing3) 0;
  text-align: right;
}
.year-picker__bottom-button {
  cursor: pointer;
  display: inline-block;
  margin-right: var(--spacing1);
  padding: var(--spacing0) var(--spacing1);
  border: none;
  border-radius: var(--border-radius);
  color: rgb(var(--white));
  background: rgb(var(--base-60));
  box-shadow: 0px 1px rgb(var(--shadow-blur)) var(--shadow-gray-dark);
}
.year-picker__bottom-button--cancel {
  color: black;
  background: rgb(var(--gray-color-5));
  box-shadow: none;
}

.year-list {
  margin: 0;
  padding: 0;
  list-style: none;
}
.year-list__item {
  padding: var(--spacing1) 0;
  display: inline-block;
}
.year-list__button {
  background: none;
  border: none;
  font-size: rgb(var(--text-size-base));
  padding: 0 var(--spacing1);
}
.year-list__button--selected {
  background: rgb(var(--base-20));
}
.year-list__button--selected-first, .year-list__button--selected-last {
  background: rgb(var(--base-60));
  color: rgb(var(--white));
}
.year-list__button--selected-first {
  border-top-left-radius: var(--border-radius);
  border-bottom-left-radius: var(--border-radius);
}
.year-list__button--selected-last {
  border-top-right-radius: var(--border-radius);
  border-bottom-right-radius: var(--border-radius);
}`, "",{"version":3,"sources":["webpack://./libs/shared/ui-year-picker/src/lib/year-picker/year-picker.component.scss"],"names":[],"mappings":"AAEA;EACI,YAAA;EACA,6BAAA;EACA,6DAAA;EACA,mCAAA;EACA,yBAAA;UAAA,iBAAA;AADJ;AAGI;EACI,iBAAA;EACA,0BAAA;EACA,iBAAA;AADR;AAII;EACI,wCAAA;AAFR;AAKI;EACI,0BAAA;EACA,iBAAA;AAHR;AAMI;EACI,eAAA;EACA,qBAAA;EACA,6BAAA;EACA,wCAAA;EACA,YAAA;EACA,mCAAA;EACA,wBAAA;EACA,+BAAA;EACA,mEAAA;AAJR;AAMQ;EACI,YAAA;EACA,oCAAA;EACA,gBAAA;AAJZ;;AASA;EACI,SAAA;EACA,UAAA;EACA,gBAAA;AANJ;AAQI;EACI,0BAAA;EACA,qBAAA;AANR;AASI;EACI,gBAAA;EACA,YAAA;EACA,qCAAA;EACA,0BAAA;AAPR;AASQ;EACI,+BAAA;AAPZ;AAUQ;EAEI,+BAAA;EACA,wBAAA;AATZ;AAYQ;EACI,4CAAA;EACA,+CAAA;AAVZ;AAaQ;EACI,6CAAA;EACA,gDAAA;AAXZ","sourcesContent":["@use \"definitions\" as *;\n\n.year-picker {\n    width: 256px;\n    background: lg-color(--white);\n    box-shadow: 0px 0px var(--shadow-blur-big) var(--shadow-gray);\n    border-radius: var(--border-radius);\n    user-select: none;\n\n    &__header {\n        font-weight: bold;\n        color: lg-color(--base-80);\n        line-height: 40px;\n    }\n\n    &__body {\n        padding: var(--spacing3) var(--spacing1);\n    }\n\n    &__bottom {\n        padding: var(--spacing3) 0;\n        text-align: right;\n    }\n\n    &__bottom-button {\n        cursor: pointer;\n        display: inline-block;\n        margin-right: var(--spacing1);\n        padding: var(--spacing0) var(--spacing1);\n        border: none;\n        border-radius: var(--border-radius);\n        color: lg-color(--white);\n        background: lg-color(--base-60);\n        box-shadow: 0px 1px lg-color(--shadow-blur) var(--shadow-gray-dark);\n\n        &--cancel {\n            color: black;\n            background: lg-color(--gray-color-5);\n            box-shadow: none;\n        }\n    }\n}\n\n.year-list {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n\n    &__item {\n        padding: var(--spacing1) 0;\n        display: inline-block;\n    }\n\n    &__button {\n        background: none;\n        border: none;\n        font-size: lg-color(--text-size-base);\n        padding: 0 var(--spacing1);\n\n        &--selected {\n            background: lg-color(--base-20);\n        }\n\n        &--selected-first,\n        &--selected-last {\n            background: lg-color(--base-60);\n            color: lg-color(--white);\n        }\n\n        &--selected-first {\n            border-top-left-radius: var(--border-radius);\n            border-bottom-left-radius: var(--border-radius);\n        }\n\n        &--selected-last {\n            border-top-right-radius: var(--border-radius);\n            border-bottom-right-radius: var(--border-radius);\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
